import {Modal, ModalProps, Space, Table} from "antd";
import {ColumnProps} from "antd/lib/table";
import { ContractStatusMapping} from "../../../utils/constants";
import {Link} from "react-router-dom";

interface ExistContractsModalProps extends ModalProps {
    records: Array<any>
}

function ExistContractsModal(props: ExistContractsModalProps) {
    const {records, ...otherProps} = props;
    const columns: Array<any> = [
        {
            dataIndex: 'code',
            title: '合同编号'
        },
        {
            dataIndex: 'hospitalName',
            title: '终端医院全称'
        },
        {
            dataIndex: 'status',
            title: '状态',
            render(v: any) {
                return ContractStatusMapping[v] || v;
            }
        },
        {
            dataIndex: 'operation',
            title: '状态',
            render(_:any,record:any){
                return <Space>
                    <a onClick={()=>window.open('/contract/contract/detail/'+record.id)}>详情</a>
                </Space>
            }
        }
    ]

    return <Modal width={800} {...otherProps} title={'合同列表'} cancelText={'关闭'}>
        <Table dataSource={records} columns={columns}></Table>
    </Modal>
}

export default ExistContractsModal;